import { Card } from '@/common/ui/Card'
import { TransactionsTable } from '@/app/entities/transactions/ui'

export const PaymentHistoryPage = () => {
    return (
        <>
            <div className='profile-content'>
                <h2 className='font-medium text-[20px]/[22px]'>История платежей и затрат</h2>
            </div>
            <Card className='profile-content' tableScroll>
                <TransactionsTable />
            </Card>
        </>
    )
}
